//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import cloneDeep from 'lodash/fp/cloneDeep';

import photoEditorConfig from './photo-editor-config';

const instagramConfig = cloneDeep(photoEditorConfig);

// This is a instagram specific version of the beautify config which includes a story post crop and
// specific language around what crops are auto-post eligible for instagram.
instagramConfig.editor.controlsOptions = {
  transform: {
    availableRatios: [
      'imgly_transform_common_custom',
      'imgly_transform_custom_square',
      'imgly_transform_common_3-4',
      'imgly_transform_common_4-5',
      'imgly_transform_common_9-16',
      'imgly_transform_common_16-9',
      'imgly_transform_common_4-3',
      'imgly_transform_common_5-4',
    ],
    ratios: [
      {
        defaultName: 'Square\n(Auto-Post Eligible)',
        identifier: 'imgly_transform_custom_square',
        ratio: 1,
      },
      {
        defaultName: '3:4\n(Auto-Post Eligible)', // The default translation for this ratio
        identifier: 'imgly_transform_common_3-4', // A unique identifier for this ratio
        ratio: 3 / 4, // The image ratio (a floating point number)
      },
      {
        defaultName: '4:5\n(Auto-Post Eligible)', // The default translation for this ratio
        identifier: 'imgly_transform_common_4-5', // A unique identifier for this ratio
        ratio: 4 / 5, // The image ratio (a floating point number)
      },
      {
        defaultName: '9:16 IG Story',
        identifier: 'imgly_transform_common_9-16',
        ratio: 9 / 16,
      },
      {
        defaultName: '5:4\n(Auto-Post Eligible)',
        identifier: 'imgly_transform_common_5-4',
        ratio: 5 / 4,
      },
    ],
  },
};
export default instagramConfig;
